import AbstractProblem from './abstractProblem';

/**
 * @class Warning
 * @extends AbstractProblem
 */
export default class Warning extends AbstractProblem {
    getBadgeType() {
        return 'warning';
    }
}
